import { useState, useCallback, forwardRef, useImperativeHandle } from "react";
import { BsBox2Fill } from "react-icons/bs";
import { Button, InputField } from "@/components";
import { FiPlus } from "react-icons/fi";
import { useFieldError, useAlert } from "@/";

const ProductDetails = ({
  onAddProduct,
  errors,
  product,
  setProduct,
  isDisabled = false,
}) => {
  const { alert, AlertDialog } = useAlert();
  const getErrorMessage = useFieldError(errors);

  const handleChange = useCallback(
    (field, value) => {
      setProduct((prev) => ({ ...prev, [field]: value }));
    },
    [setProduct]
  );

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate fields
    const { productName, quantity, orderValue, sku } = product;
    if (!productName || !quantity || !orderValue || !sku) {
      alert("All fields are required.");
      return;
    }

    // Ensure quantity and values are positive
    if (quantity <= 0 || orderValue <= 0) {
      alert("Quantity and Order Value must be positive numbers.");
      return;
    }

    // Pass product data to parent component
    onAddProduct(product);

    // Reset form
    setProduct({
      productName: "",
      quantity: "",
      orderValue: "",
      hsn: "",
      sku: "",
    });
  };

  return (
    <div className="h-fit flex flex-col gap-2 border-2 border-secondary/30 rounded-2xl p-4">
      <div className="flex gap-2 items-center">
        <BsBox2Fill className="text-headline4 text-secondary/80" />
        <h2 className="text-headline4 text-secondary/80 font-nunito font-semibold">
          Product Details
        </h2>
      </div>

      {getErrorMessage("products") && (
        <span className="text-red-500 text-sm">
          {getErrorMessage("products")}
        </span>
      )}

      <form
        onSubmit={handleSubmit}
        className="flex flex-col md:flex-row gap-2 items-center"
      >
        <InputField
          type="text"
          label="Product Name"
          placeholder="Enter product name"
          value={product.productName}
          onChange={(value) => handleChange("productName", value)}
          disabled={isDisabled}
        />
        <InputField
          type="number"
          label="Quantity"
          placeholder="Eg. 20"
          value={product.quantity}
          onChange={(value) => handleChange("quantity", value)}
          min="1"
          disabled={isDisabled}
        />
        <InputField
          type="number"
          label="Order Value"
          placeholder="Enter order value"
          value={product.orderValue}
          onChange={(value) => handleChange("orderValue", value)}
          min="1"
          disabled={isDisabled}
        />
        <InputField
          label="HSN No (optional)"
          placeholder="Enter HSN No"
          value={product.hsn}
          onChange={(value) => handleChange("hsn", value)}
          disabled={isDisabled}
        />
        <InputField
          label="SKU No"
          placeholder="Enter SKU No"
          value={product.sku}
          onChange={(value) => handleChange("sku", value)}
          disabled={isDisabled}
        />
        <div className="w-full md:w-fit h-full flex items-end pt-5">
          <Button
            variant="default"
            size="md"
            className="w-full min-h-[46px] mb-[1px] h-fit"
            type="submit"
            disabled={isDisabled}
          >
            ADD
          </Button>
        </div>
      </form>
      <AlertDialog />
    </div>
  );
};

ProductDetails.displayName = "ProductDetails";

export default ProductDetails;
